import { createSelector } from '@ngrx/store';

import * as fromFeature from '../reducers';
import * as fromSearch from '../reducers/search.reducer';
import * as fromRoot from '../../../store';
import { ToEntities } from 'src/app/utility';
import { Product } from '../../models';

// tslint:disable-next-line:max-line-length
export const getSearchState = createSelector(fromFeature.getShopifyState, (state: fromFeature.ShopifyState) => state.search);

export const getSearchResults = createSelector(getSearchState, fromSearch.getSearchResults);
export const getGlobalSearchResults = createSelector(getSearchState, fromSearch.getGlobalSearchResults);

export const getSearchLoaded = createSelector(getSearchState, fromSearch.getSearchLoaded);
export const getSearchLoading = createSelector(getSearchState, fromSearch.getSearchLoading);

export const getGlobalSearchLoaded = createSelector(getSearchState, fromSearch.getGlobalSearchLoaded);
export const getGlobalSearchLoading = createSelector(getSearchState, fromSearch.getGlobalSearchLoading);

export const getSearchPageInfo = createSelector(getSearchState, fromSearch.getSearchPageInfo);
export const getSearchQuery = createSelector(getSearchState, fromSearch.getSearchQuery);
export const getGlobalSearchQuery = createSelector(getSearchState, fromSearch.getGlobalSearchQuery);
